import { CheckboxBlankBadgeIcon } from './CheckboxBlankBadgeIcon';

/**
 * author: Michael Irigoyen
 * id 22ECB099-6A57-4DA8-9E42-0E3D8000C003
 * name checkbox-blank-badge
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-badge.svg
 * tags
 * - Notification 
 * - Form 
 */
export const CheckboxBlankNotificationIcon = CheckboxBlankBadgeIcon;
export default CheckboxBlankNotificationIcon